module.exports = __webpack_public_path__ + "static/img/preview_title3.011d614.png";


//////////////////
// WEBPACK FOOTER
// ./static/funding_cpunk/creation/preview_title3.png
// module id = QvaR
// module chunks = 1